import { useLiteAppContext } from "@app/helpers/hooks";

export const useSeatSelectionFirst = () => {
  const { features } = useLiteAppContext();

  return {
    is_seat_selection_first_enabled: !!features.SEAT_SELECTION_FIRST
  };
};
